import { useMemo } from 'react';
import { ApiClient } from './api';
import { useSession } from './auth';
import { useConfig } from './config';

/**
 * API client bound to the runtime config and the current session. The token getter reads the
 * latest access token at call time, so the client instance stays stable across token renewals.
 * In dev-claims mode (local/CI only) the client sends `x-dev-claims` instead of a bearer token.
 */
export function useApiClient(): ApiClient {
  const { apiBaseUrl } = useConfig();
  const { getAccessToken, devClaims } = useSession();
  return useMemo(
    () =>
      new ApiClient({
        baseUrl: apiBaseUrl,
        getAccessToken,
        defaultHeaders: devClaims ? { 'x-dev-claims': JSON.stringify(devClaims) } : undefined,
      }),
    [apiBaseUrl, getAccessToken, devClaims],
  );
}
